module.exports = __webpack_public_path__ + "assets/icon-radiobox.e203ba07.svg";